<div class="table-container">
  <form [formGroup]="GFMgmtForm" autocomplete="off">
    <ng-container formArrayName="GFMgmtRows">
      <mat-toolbar class="header heading-background">
        <div class="col-lg-8">
          <h5>
            Group Functions Management
          </h5>
        </div>
        <div class="col-lg-4 search-container">
          <div (change)="updateFilteredData()" (keyup)="updateFilteredData()" style="width:100%">
            <input class="form-control" type="text" placeholder="Search" [(ngModel)]="searchString" [ngModelOptions]="{standalone: true}">
          </div>
        </div>
      </mat-toolbar>
      <div class="table-scroll-container">
        <table #objTable
          mat-table
          matSort
          [dataSource]="dataSource"
          class="mat-elevation-z8 mat-table-custom sticky-table">


          <!-- MgmtId Column -->
          <ng-container matColumnDef="mgmtId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="mgmtId" style="width:20%">MgmtId</th>
            <td mat-cell *matCellDef="let element" style="width:20%">
              <div [innerHTML]="element.mgmtId"></div>
            </td>
          </ng-container>

          <!-- Mgmt Name Column -->
          <ng-container matColumnDef="mgmtName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="mgmtName" style="width:50%">MgmtName</th>
            <td mat-cell *matCellDef="let element" style="width:50%">
              <div [innerHTML]="element.mgmtName"></div>
            </td>
          </ng-container>

          <!-- Group Function Column -->
          <ng-container matColumnDef="groupFunction">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="groupFunction" style="width:30%; margin-right:10px">GroupFunction</th>
            <td mat-cell *matCellDef="let element" style="width: 30%; margin-right: 10px">
              @if (data.isReadOnly) {
                <div [innerHTML]="getSelectorText(element.groupFunction)"></div>
              }
              @if (!data.isReadOnly) {
                <mat-select [(ngModel)]="element.groupFunction"
                  [ngModelOptions]="{standalone: true}"
                  multiple
                  (selectionChange)="onSelectionChange($event, element.mgmtId)">
                  <mat-select-trigger>
                    <ng-container>
                      {{ getSelectorText(element.groupFunction) }}
                    </ng-container>
                  </mat-select-trigger>
                  @for (gf of data.availableGroupFunctions; track gf) {
                    <mat-option [value]="gf">
                      {{gf}}
                    </mat-option>
                  }
                </mat-select>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; let i = index; columns: columnsToDisplay;"></tr>
        </table>
      </div>
      <div class="footer-buttons">
        <button (click)="onDownload()" type="button" mat-raised-button
          matTooltip="Download data"
          class="btn button-fix button-color-fix-purple download-left">
          Download
          <mat-icon class="icon-color-fix">download</mat-icon>
        </button>
        <button (click)="onBack()" mat-raised-button class="btn button-fix button-color-fix-red" style="margin-right:5px">
          <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
          Back
        </button>
        @if (!data.isReadOnly) {
          <button mat-raised-button type="submit" (click)="onSave()"
            [disabled]="!anyChange()"
            [matTooltip]="anyChange()? 'Save changes' : 'Save disabled. Make any change.'"
            class="btn button-fix button-color-fix-orange">
            Save
            <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
          </button>
        }
      </div>
    </ng-container>
  </form>
</div>
